import pdfTailwindTheme from "./pdfTailwindTheme.json";

// react-pdf-tailwind v3 expects a flat theme object (like tailwindcss/defaultTheme),
// not a nested Tailwind config. Properties must be at the top level.
const pdfTheme = {
  ...pdfTailwindTheme.theme,
  ...pdfTailwindTheme.theme.extend,
  // Override fontFamily to only include registered fonts (react-pdf can't use system fonts like ui-sans-serif)
  fontFamily: {
    ...pdfTailwindTheme.theme.fontFamily,
    sans: ["Hanken Grotesk"],
    serif: ["Fraunces"],
  },
  colors: {
    ...pdfTailwindTheme.theme.extend.colors,
    // Resolve CSS variable colors to static HSL values (from styles/tailwind.css :root)
    border: "hsl(214.3, 31.8%, 91.4%)",
    input: "hsl(214.3, 31.8%, 91.4%)",
    "ring-3": "hsl(222.2, 84%, 4.9%)",
    background: "hsl(0, 0%, 100%)",
    foreground: "hsl(222.2, 84%, 4.9%)",
    primary: {
      DEFAULT: "hsl(222.2, 47.4%, 11.2%)",
      foreground: "hsl(210, 40%, 98%)",
    },
    secondary: {
      DEFAULT: "hsl(210, 40%, 96.1%)",
      foreground: "hsl(222.2, 47.4%, 11.2%)",
    },
    destructive: {
      DEFAULT: "hsl(0, 84.2%, 60.2%)",
      background: "hsl(359, 81%, 72%)",
      foreground: "hsl(210, 40%, 98%)",
    },
    muted: {
      DEFAULT: "hsl(210, 40%, 96.1%)",
      foreground: "hsl(215.4, 16.3%, 46.9%)",
    },
    accent: {
      DEFAULT: "hsl(210, 40%, 96.1%)",
      foreground: "hsl(222.2, 47.4%, 11.2%)",
    },
    popover: {
      DEFAULT: "hsl(0, 0%, 100%)",
      foreground: "hsl(222.2, 84%, 4.9%)",
    },
    card: {
      DEFAULT: "hsl(0, 0%, 100%)",
      foreground: "hsl(222.2, 84%, 4.9%)",
    },
  },
  borderRadius: {
    ...pdfTailwindTheme.theme.extend.borderRadius,
    // --radius: 0.5rem from styles/tailwind.css
    lg: "0.5rem",
    md: "0.375rem", // calc(0.5rem - 2px)
    sm: "0.25rem", // calc(0.5rem - 4px)
  },
};

export default pdfTheme;
